/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { IntervalStore } from '../stores';

export const IntervalContext = createContext<IntervalStore>({} as IntervalStore);
